import React, { useEffect, useState, useContext } from 'react';
import LayoutContainer from 'components/layout/LayoutContainer';
import AdminHeader from 'components/header';
import { Col, Row, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Card from 'components/inputs/Card';
import Button from 'components/inputs/Button';
import { FiEdit2 } from 'react-icons/fi';
import * as _ from 'lodash';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import { NavContext } from 'components/privateRoute/PrivateRoute';
import { getMuralArts } from 'api/muralArt';
import { formatOfferDate } from 'view/sessionLevelOffer/SessionLevelOfferList';

const MuralArtList = () => {
  const { navigateTo } = useContext(NavContext);
  const [data, setData] = useState(null);

  useEffect(() => {
    getMuralArts()
      .then((res) => setData(res.data))
      .catch(() => setData([]));
  }, []);

  return (
    <React.Fragment>
      <LayoutContainer>
        <AdminHeader title="SHWA Murals" />
        <SkeletonTheme baseColor="#1b2a38" highlightColor="#15212b" enableAnimation="true">
          <div className="page-content-wrapper scrollable">
            <div className="user-group-page_main">
              <div className="user-group-main-block">
                <Card>
                  <div className="user-group-block">
                    <div className="user-group-search-box">
                      <Row className="align-items-center">
                        <Col className="d-flex justify-content-end">
                          <Button className="user-group-btn" onClick={() => navigateTo('/addMuralArt')}>
                            Add Mural
                          </Button>
                        </Col>
                      </Row>
                    </div>
                    <div className="user-group-table">
                      <div className="table-responsive">
                        <table className="record-list-table">
                          <thead>
                            <tr>
                              <th className="px-3">Name</th>
                              <th className="px-3">Artist</th>
                              <th className="px-3">Stations</th>
                              <th className="px-3">Images</th>
                              <th className="px-3">Updated</th>
                              <th className="px-3 action-col">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {data === null ? (
                              <tr>
                                <td colSpan={6} className="border-0">
                                  <Skeleton height={15} />
                                </td>
                              </tr>
                            ) : _.isEmpty(data) ? (
                              <tr>
                                <td colSpan={6} className="border-0">
                                  <div className="empty-data-block">No murals yet</div>
                                </td>
                              </tr>
                            ) : (
                              _.map(data, (mural) => (
                                <tr key={mural.id}>
                                  <td className="px-3">{mural.name}</td>
                                  <td className="px-3">{_.get(mural, 'artist.name', '-')}</td>
                                  <td className="px-3">
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={<Tooltip id={`stations-${mural.id}`}>{_.map(mural.stations, 'name').join(', ') || '-'}</Tooltip>}
                                    >
                                      <span>
                                        {mural.stations.length} {mural.stations.length === 1 ? 'station' : 'stations'}
                                      </span>
                                    </OverlayTrigger>
                                  </td>
                                  <td className="px-3">{_.size(mural.images)}</td>
                                  <td className="px-3">{formatOfferDate(mural.updatedAt)}</td>
                                  <td className="px-3">
                                    <span className="user-group-table-editIcon" title="Edit" onClick={() => navigateTo(`/editMuralArt/${mural.id}`)}>
                                      <FiEdit2 />
                                    </span>
                                  </td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </Card>
              </div>
            </div>
          </div>
        </SkeletonTheme>
      </LayoutContainer>
    </React.Fragment>
  );
};

export default MuralArtList;
